import React from "react";
import { Pressable, View } from "react-native";
import color from "@constants/color";
import Text from "@components/CustomText";
import { signUpSuccessfulStyles as styles } from "./styles";
import { useFlowNavigation } from "./useFlowNavigation";

const SignUpSuccessful: React.FC = () => {
  const { goToNextStep } = useFlowNavigation();

  return (
    <>
      <View style={styles.container}>
        <View style={styles.iconWrapper}>
          <Text style={styles.iconEmoji}>📄</Text>
        </View>

        <Text variant="heading_24" style={styles.title}>
          Sign Up Successful
        </Text>
        <Text variant="body_text_1" style={styles.subtitle}>
          You will receive a confirmation after your documents are reviewed and
          approved
        </Text>

        <Pressable
          style={styles.okayButton}
          onPress={goToNextStep}
          accessibilityRole="button"
          accessibilityLabel="Okay"
        >
          <Text variant="title_16" style={styles.okayButtonText}>
            Okay
          </Text>
        </Pressable>
      </View>
    </>
  );
};

export default SignUpSuccessful;
